<template>
  <img :src="getIcon()" alt="icon">
</template>

<script>
import iconConst from "@/constants/icon-const";

export default {
  name: 'IconComponent',
	props: {
		iconName: {
			type: String,
      require: true,
		},
		fullSrc: {
			type: String,
      require: false,
			default: '',
		},
	},
	methods: {
		getIcon() {
			if (this.fullSrc) {
				return this.fullSrc;
			} else {
				return iconConst[`${this.iconName}`];
			};
		},
	},
}
</script>

<style lang="less" scoped>

</style>